var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"OrderSuccess":_vm.OrderSuccess,"PtOrderSuccess":_vm.PtOrderSuccess,"SingleOrderSuccess":_vm.SingleOrderSuccess}})}
var staticRenderFns = []

export { render, staticRenderFns }